document.documentElement.classList.add("js");

const menuButton = document.querySelector("[data-menu-button]");
const menu = document.querySelector("[data-menu]");
if (menuButton && menu) {
  menuButton.addEventListener("click", () => {
    const open = menuButton.getAttribute("aria-expanded") === "true";
    menuButton.setAttribute("aria-expanded", String(!open));
    menu.toggleAttribute("data-open", !open);
  });
}

const installButton = document.querySelector("[data-install-button]");
let installPrompt;
if (installButton && !window.matchMedia("(display-mode: standalone)").matches) {
  window.addEventListener("beforeinstallprompt", event => {
    event.preventDefault();
    installPrompt = event;
    installButton.hidden = false;
    installButton.toggleAttribute("data-available", true);
  });
  installButton.addEventListener("click", async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    await installPrompt.userChoice;
    installPrompt = null;
    installButton.hidden = true;
    installButton.removeAttribute("data-available");
  });
  window.addEventListener("appinstalled", () => {
    installPrompt = null;
    installButton.hidden = true;
    installButton.removeAttribute("data-available");
  });
}

const widget = document.querySelector("emp-cartells-agenda");
const widgetStatus = document.querySelector("[data-widget-status]");
if (widget && widgetStatus) {
  const timeout = window.setTimeout(() => {
    if (!customElements.get("emp-cartells-agenda")) widgetStatus.hidden = false;
  }, 4500);
  customElements.whenDefined("emp-cartells-agenda").then(() => {
    window.clearTimeout(timeout);
    widgetStatus.hidden = true;
  });
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js"));
}

(() => {
  "use strict";
  const form = document.querySelector("[data-subscription-form]");
  const dialog = document.querySelector("[data-subscription-dialog]");
  const status = document.querySelector("[data-subscription-status]");
  const messages = document.querySelector("[data-subscription-messages]");
  if (!form || !dialog || !status || !messages) return;

  const email = form.elements.email;
  const submit = form.querySelector('button[type="submit"]');
  const confirm = dialog.querySelector("[data-subscription-confirm]");
  const cancel = dialog.querySelector("[data-subscription-cancel]");

  form.addEventListener("submit", event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    dialog.showModal();
  });

  cancel.addEventListener("click", () => dialog.close());
  dialog.addEventListener("click", event => {
    if (event.target === dialog) dialog.close();
  });

  confirm.addEventListener("click", async () => {
    const subscriptionBase = document.body.dataset.subscriptionUrl?.replace(/\/$/, "");
    if (!subscriptionBase) return;
    dialog.close();
    submit.disabled = true;
    confirm.disabled = true;
    status.removeAttribute("data-error");
    status.textContent = messages.dataset.sending;
    try {
      const response = await fetch(`${subscriptionBase}/api/subscription/petition`, {
        method: "POST",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        credentials: "include",
        body: new URLSearchParams({to: email.value.trim()})
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      form.reset();
      status.textContent = messages.dataset.sent;
    } catch {
      status.dataset.error = "";
      status.textContent = messages.dataset.error;
    } finally {
      submit.disabled = false;
      confirm.disabled = false;
    }
  });
})();

(() => {
  "use strict";

  const CONSENT_ENABLED = false;
  const CONSENT_COOKIE = "yuppiya-consent-v1";
  const CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 180;
  const translations = {
    ca: {
      title: "Privacitat i cookies",
      intro: "Utilitzem cookies tècniques per fer funcionar Agenda YuppiYa. Amb el teu permís, també podem utilitzar Google Analytics per mesurar l’ús del web.",
      necessary: "Cookies tècniques necessàries", necessaryHelp: "Sempre actives perquè el web pugui funcionar.",
      analytics: "Analítica", analyticsHelp: "Google Analytics ens ajuda a entendre com s’utilitza Agenda YuppiYa.",
      accept: "Accepta-ho tot", reject: "Rebutja-ho tot", configure: "Configura",
      save: "Desa la selecció", settings: "Configura les cookies", privacy: "Més informació"
    },
    es: {
      title: "Privacidad y cookies",
      intro: "Utilizamos cookies técnicas para que Agenda YuppiYa funcione. Con tu permiso, también podemos utilizar Google Analytics para medir el uso de la web.",
      necessary: "Cookies técnicas necesarias", necessaryHelp: "Siempre activas para que la web pueda funcionar.",
      analytics: "Analítica", analyticsHelp: "Google Analytics nos ayuda a entender cómo se utiliza Agenda YuppiYa.",
      accept: "Aceptar todo", reject: "Rechazar todo", configure: "Configurar",
      save: "Guardar selección", settings: "Configurar las cookies", privacy: "Más información"
    },
    fr: {
      title: "Confidentialité et cookies",
      intro: "Nous utilisons des cookies techniques pour faire fonctionner Agenda YuppiYa. Avec votre accord, nous pouvons également utiliser Google Analytics pour mesurer l’utilisation du site.",
      necessary: "Cookies techniques nécessaires", necessaryHelp: "Toujours actifs pour assurer le fonctionnement du site.",
      analytics: "Mesure d’audience", analyticsHelp: "Google Analytics nous aide à comprendre l’utilisation d’Agenda YuppiYa.",
      accept: "Tout accepter", reject: "Tout refuser", configure: "Configurer",
      save: "Enregistrer la sélection", settings: "Configurer les cookies", privacy: "En savoir plus"
    },
    en: {
      title: "Privacy and cookies",
      intro: "We use technical cookies to make Agenda YuppiYa work. With your permission, we may also use Google Analytics to measure use of the website.",
      necessary: "Necessary technical cookies", necessaryHelp: "Always active so the website can work.",
      analytics: "Analytics", analyticsHelp: "Google Analytics helps us understand how Agenda YuppiYa is used.",
      accept: "Accept all", reject: "Reject all", configure: "Configure",
      save: "Save selection", settings: "Cookie settings", privacy: "More information"
    }
  };

  const language = (document.documentElement.lang || "ca").toLowerCase().split("-")[0];
  const text = translations[language] || translations.ca;
  let consent = CONSENT_ENABLED ? readConsent() : null;
  let banner;
  let settingsButton;

  function readConsent() {
    const prefix = `${CONSENT_COOKIE}=`;
    const item = document.cookie.split(";").map(value => value.trim()).find(value => value.startsWith(prefix));
    if (!item) return null;
    try {
      const parsed = JSON.parse(decodeURIComponent(item.slice(prefix.length)));
      return typeof parsed.analytics === "boolean" ? parsed : null;
    } catch {
      return null;
    }
  }

  function writeConsent(nextConsent) {
    const secure = location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${CONSENT_COOKIE}=${encodeURIComponent(JSON.stringify(nextConsent))}; Max-Age=${CONSENT_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
  }

  function clearAnalyticsCookies() {
    const names = document.cookie.split(";")
      .map(item => item.trim().split("=")[0])
      .filter(name => /^(_ga|_gid|_gat)/.test(name));
    const parts = location.hostname.split(".");
    const parentDomain = parts.length > 2 ? `.${parts.slice(-2).join(".")}` : null;
    names.forEach(name => {
      document.cookie = `${name}=; Max-Age=0; Path=/`;
      if (parentDomain) document.cookie = `${name}=; Max-Age=0; Path=/; Domain=${parentDomain}`;
    });
  }

  function saveConsent(analytics) {
    const revoked = Boolean(consent?.analytics && !analytics);
    consent = {analytics, updatedAt: new Date().toISOString()};
    writeConsent(consent);
    closeBanner();
    showSettingsButton();
    if (revoked) {
      clearAnalyticsCookies();
      location.reload();
    } else if (analytics) {
      window.dispatchEvent(new CustomEvent("yuppiya:analytics-consent"));
    }
  }

  function createChoice(name, label, help, checked, disabled = false) {
    const wrapper = document.createElement("label");
    wrapper.className = "consent-choice";
    const input = document.createElement("input");
    input.type = "checkbox";
    input.name = name;
    input.checked = checked;
    input.disabled = disabled;
    const copy = document.createElement("span");
    const title = document.createElement("strong");
    title.textContent = label;
    const description = document.createElement("small");
    description.textContent = help;
    copy.append(title, description);
    wrapper.append(input, copy);
    return wrapper;
  }

  function showConfiguration(options, saveButton, configureButton) {
    options.replaceChildren(
      createChoice("necessary", text.necessary, text.necessaryHelp, true, true),
      createChoice("analytics", text.analytics, text.analyticsHelp, Boolean(consent?.analytics))
    );
    options.hidden = false;
    saveButton.hidden = false;
    configureButton.hidden = true;
  }

  function showBanner(configure = false) {
    if (banner) {
      if (configure) showConfiguration(
        banner.querySelector("[data-consent-options]"),
        banner.querySelector("[data-consent-save]"),
        banner.querySelector("[data-consent-configure]")
      );
      banner.querySelector("h2").focus();
      return;
    }
    banner = document.createElement("section");
    banner.className = "consent-banner";
    banner.setAttribute("role", "dialog");
    banner.setAttribute("aria-modal", "true");
    banner.setAttribute("aria-labelledby", "consent-title");
    const panel = document.createElement("div");
    panel.className = "consent-panel";
    const title = document.createElement("h2");
    title.id = "consent-title";
    title.tabIndex = -1;
    title.textContent = text.title;
    const intro = document.createElement("p");
    intro.textContent = text.intro;
    const privacy = document.createElement("a");
    privacy.href = document.body.dataset.cookiePolicyUrl;
    privacy.textContent = text.privacy;
    const options = document.createElement("div");
    options.className = "consent-options";
    options.dataset.consentOptions = "";
    options.hidden = true;
    const actions = document.createElement("div");
    actions.className = "consent-actions";
    const accept = document.createElement("button");
    accept.type = "button";
    accept.dataset.consentAccept = "";
    accept.textContent = text.accept;
    accept.addEventListener("click", () => saveConsent(true));
    const reject = document.createElement("button");
    reject.type = "button";
    reject.dataset.consentReject = "";
    reject.textContent = text.reject;
    reject.addEventListener("click", () => saveConsent(false));
    const configureButton = document.createElement("button");
    configureButton.type = "button";
    configureButton.className = "consent-secondary";
    configureButton.dataset.consentConfigure = "";
    configureButton.textContent = text.configure;
    const save = document.createElement("button");
    save.type = "button";
    save.className = "consent-secondary";
    save.dataset.consentSave = "";
    save.hidden = true;
    save.textContent = text.save;
    configureButton.addEventListener("click", () => showConfiguration(options, save, configureButton));
    save.addEventListener("click", () => saveConsent(options.querySelector('[name="analytics"]').checked));
    actions.append(reject, configureButton, accept, save);
    panel.append(title, intro, privacy, options, actions);
    banner.append(panel);
    document.body.append(banner);
    if (configure) showConfiguration(options, save, configureButton);
    title.focus();
  }

  function closeBanner() {
    banner?.remove();
    banner = null;
  }

  function showSettingsButton() {
    if (settingsButton) return;
    settingsButton = document.createElement("button");
    settingsButton.type = "button";
    settingsButton.className = "consent-settings";
    settingsButton.setAttribute("aria-label", text.settings);
    settingsButton.title = text.settings;
    settingsButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.4 10.2a4 4 0 0 1-5.2-5.2A8.5 8.5 0 1 0 20.4 10.2Z"/><circle cx="8" cy="10" r="1"/><circle cx="11" cy="16" r="1"/><circle cx="6.5" cy="15" r=".8"/></svg>';
    settingsButton.addEventListener("click", () => showBanner(true));
    document.body.append(settingsButton);
  }

  window.yuppiyaAnalyticsAllowed = () => !CONSENT_ENABLED || Boolean(consent?.analytics);
  if (!CONSENT_ENABLED) return;
  if (consent) showSettingsButton();
  else showBanner();
})();

(() => {
  "use strict";
  const measurementId = "G-1YB5SWQ7NP";
  let loaded = false;

  function loadAnalytics() {
    if (loaded || !window.yuppiyaAnalyticsAllowed?.()) return;
    loaded = true;
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.append(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", measurementId);
  }

  window.addEventListener("yuppiya:analytics-consent", loadAnalytics);
  loadAnalytics();
})();
